'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentTextFormat = function ContentTextFormat(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M5 17v2h14v-2H5zm4.5-4.2h5l.9 2.2h2.1L12.75 4h-1.5L6.5 15h2.1l.9-2.2zM12 5.98L13.87 11h-3.74L12 5.98z' })
  );
};
ContentTextFormat = (0, _pure2.default)(ContentTextFormat);
ContentTextFormat.displayName = 'ContentTextFormat';
ContentTextFormat.muiName = 'SvgIcon';

exports.default = ContentTextFormat;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/content/text-format.js
// module id = 2843
// module chunks = 0